"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeakAuthResolver_1 = __importDefault(require("./utilities/PeakAuthResolver"));
const PeakAuthClient_1 = __importDefault(require("./clients/PeakAuthClient"));
const PeakAuthClients_1 = __importDefault(require("./PeakAuthClients"));
const PeakAuthQueryStrings_1 = __importDefault(require("./utilities/PeakAuthQueryStrings"));
const UriHelper_1 = __importDefault(require("./utilities/UriHelper"));
const QueryStringHelper_1 = __importDefault(require("./utilities/QueryStringHelper"));
const PeakAuthWith_1 = __importDefault(require("./PeakAuthWith"));
const rxjs_1 = require("rxjs");
const PeakAuthConstants_1 = __importDefault(require("./utilities/PeakAuthConstants"));
class PeakAuth {
    constructor(baseUri, service, redirectUri, userCredentials, resolver = PeakAuthResolver_1.default.Instance) {
        this.baseUri = baseUri;
        this.service = service;
        this.redirectUri = redirectUri;
        this.userCredentials = userCredentials;
        this.resolver = resolver;
        this.isEnsured = false;
        this.baseUri = this.resolver.baseUri(baseUri);
        this.service = this.resolver.service(service);
        this.redirectUri = this.resolver.redirectUri(redirectUri);
        this.client = new PeakAuthClient_1.default(this.resolver.baseUri(baseUri), this.service, this.userCredentials, this.resolver, () => __awaiter(this, void 0, void 0, function* () { return yield this.processVerifyAsync(); }));
        this.clients = new PeakAuthClients_1.default(this.client);
        this.with = new PeakAuthWith_1.default(this);
    }
    to(p) {
        return p.then(v => [null, v]).catch(err => [err]);
    }
    redirect(uri) { window.location.href = uri; }
    reauth(asAdmin = false, redirect = true, autoLogin = false) { return rxjs_1.scheduled(this.reauthAsync(asAdmin, redirect, autoLogin), rxjs_1.asyncScheduler); }
    reauthAsync(asAdmin = false, redirect = true, autoLogin = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let [err, data] = yield this.to(this.clients.logout.postAsync());
            this.resolver.cache.tokenResponse.remove();
            this.resolver.cache.code.remove();
            this.resolver.cache.refreshCode.remove();
            if (!this.resolver.isAuth() && redirect)
                this.redirect(this.client.resolveUri({ queryStrings: { service: this.resolver.service(), redirect_uri: this.resolver.redirectUri(), admin_consent: asAdmin, auto_login: autoLogin } }));
        });
    }
    process(reauth = true) { return rxjs_1.scheduled(this.processAsync(reauth), rxjs_1.asyncScheduler); }
    processAsync(reauth = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hasErrors())
                return;
            if (this.processCompletedRequest())
                return;
            if (this.processCode())
                return;
            yield this.processVerifyAsync(reauth);
        });
    }
    hasErrors() { return PeakAuthQueryStrings_1.default.status === 'error' || !!PeakAuthQueryStrings_1.default.error; }
    processCompletedRequest() {
        if (this.resolver.isAuth() && PeakAuthQueryStrings_1.default.status === PeakAuthConstants_1.default.completed && PeakAuthQueryStrings_1.default.code && PeakAuthQueryStrings_1.default.refreshCode && PeakAuthQueryStrings_1.default.redirectUri) {
            this.resolver.cache.tokenResponse.remove();
            this.resolver.cache.code.value = PeakAuthQueryStrings_1.default.code;
            this.resolver.cache.refreshCode.value = PeakAuthQueryStrings_1.default.refreshCode;
            this.resolver.cache.isAuthCompleted.value = true;
            this.redirect(UriHelper_1.default.resolve({
                base: this.resolver.redirectUri(),
                queryStrings: {
                    code: this.resolver.code(),
                    refresh_code: this.resolver.refreshCode()
                }
            }));
            return true;
        }
        return false;
    }
    processCode() {
        if (PeakAuthQueryStrings_1.default.code || PeakAuthQueryStrings_1.default.refreshCode) {
            this.resolver.cache.tokenResponse.remove();
            let url = "";
            if (PeakAuthQueryStrings_1.default.code) {
                this.resolver.cache.code.value = PeakAuthQueryStrings_1.default.code;
                url = QueryStringHelper_1.default.Remove(PeakAuthConstants_1.default.code, url);
            }
            if (PeakAuthQueryStrings_1.default.refreshCode) {
                this.resolver.cache.refreshCode.value = PeakAuthQueryStrings_1.default.refreshCode;
                url = QueryStringHelper_1.default.Remove(PeakAuthConstants_1.default.refreshCode, url);
            }
            if (url)
                this.redirect(url);
            return true;
        }
        return false;
    }
    processVerify() { return rxjs_1.scheduled(this.processVerifyAsync(), rxjs_1.asyncScheduler); }
    processVerifyAsync(reauth = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenResponse = yield this.provideTokenAsync(this.userCredentials, !this.isEnsured);
            //console.log("Token response", this.tokenResponse);
            if (tokenResponse) {
                this.isEnsured = true;
                this.handleToken(tokenResponse);
                let verifyModel = yield this.clients.verify.getAsync(tokenResponse.access_token);
                if (verifyModel.result && this.resolver.isAuth())
                    this.redirect(UriHelper_1.default.resolve({
                        base: this.resolver.redirectUri(),
                        queryStrings: {
                            code: tokenResponse.access_token,
                            refresh_code: tokenResponse.refresh_token
                        }
                    }));
            }
            else if (reauth)
                yield this.reauthAsync(false, reauth, true);
        });
    }
    provideTokenAsync(userCredentials, ensure = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let curr = null;
            //console.log("Trying to resolve from model or cache");
            if (this.resolver.cache.tokenResponse.value)
                curr = this.processTokenResponse(this.resolver.cache.tokenResponse.value, false);
            if (ensure && curr) {
                //console.log("Ensuring the token.");
                curr = this.processTokenResponse(yield this.clients.oauth.accessTokenAsync(curr.access_token));
            }
            if (this.isAccessTokenValid(curr))
                return curr;
            //console.log("Trying to resolve from refresh token");
            if (curr)
                curr = this.processTokenResponse(yield this.clients.oauth.refreshTokenAsync(curr.refresh_token));
            if (this.isAccessTokenValid(curr))
                return curr;
            //console.log("Cleaning the cache and trying to resolve from standalone token");
            this.resolver.cache.tokenResponse.remove();
            if (this.resolver.code())
                curr = this.processTokenResponse(yield this.clients.oauth.accessTokenAsync());
            if (this.isAccessTokenValid(curr))
                return curr;
            //console.log("Trying to resolve from standalone refresh token");
            if (this.resolver.refreshCode())
                curr = this.processTokenResponse(yield this.clients.oauth.refreshTokenAsync());
            if (this.isAccessTokenValid(curr))
                return curr;
            //console.log("Trying to resolve from user credentials and keys");
            if (userCredentials && userCredentials.key && userCredentials.secret)
                curr = this.processTokenResponse(yield this.clients.oauth.credentialAsync(userCredentials.key, userCredentials.secret));
            if (this.isAccessTokenValid(curr))
                return curr;
            //console.log("Couldn't resolve token.");
            return null;
        });
    }
    processTokenResponse(model, updateCache = true) {
        if (this.isAccessTokenValid(model)) {
            if (updateCache)
                this.resolver.cache.tokenResponse.value = model;
            return model;
        }
        return null;
    }
    isAccessTokenValid(model) {
        return (model && model.access_token && new Date((model.retires_at || 0) * 1000 /* Because Date takes a millisecond. I'm not surprised. */) > new Date(Date.now())) || false;
    }
    handleWith(model, redirect = true) {
        if (model.result) {
            if (model.code) {
                this.resolver.cache.code.value = model.code;
            }
            if (model.refreshCode) {
                this.resolver.cache.refreshCode.value = model.refreshCode;
            }
            if (model.completeUri && redirect) {
                this.redirect(model.completeUri);
            }
        }
    }
    handleToken(model) {
        if (model) {
            this.resolver.cache.tokenResponse.value = model;
            if (model.access_token) {
                this.resolver.cache.code.value = model.access_token;
            }
            if (model.refresh_token) {
                this.resolver.cache.refreshCode.value = model.refresh_token;
            }
        }
    }
}
exports.default = PeakAuth;
